import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layers-behind, slides, pages"} maskId="square-filled-radius-0-stroke-1-IconLayersBehind"><path d="M4 3V4H20V3H4Z" fill="currentColor"/><path d="M2 6V20H22V6H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayersBehind;
